import { StoreState } from "../../../Store";
import { Mask, MaskServer, Commands, CommandServer } from "../../../shared";

export const intervalNumMap: State.IntervalNumMap = {
  60: "1 minute",
  900: "15 minutes",
  1800: "30 minutes",
  2700: "45 minutes",
  3600: "60 minutes",
  86400: "1 day",
  604800: "1 week"
};
export const intervalStrMap: State.IntervalStrMap = {
  "1 minute": 60,
  "15 minutes": 900,
  "30 minutes": 1800,
  "45 minutes": 2700,
  "60 minutes": 3600,
  "1 day": 86400,
  "1 week": 604800
};

export namespace State {
  export type INTERVAL_STR_1_MINUTE = "1 minute";
  export type INTERVAL_STR_15_MINUTES = "15 minutes";
  export type INTERVAL_STR_30_MINUTES = "30 minutes";
  export type INTERVAL_STR_45_MINUTES = "45 minutes";
  export type INTERVAL_STR_60_MINUTES = "60 minutes";
  export type INTERVAL_STR_1_DAY = "1 day";
  export type INTERVAL_STR_1_WEEK = "1 week";
  export type INTERVAL_NUM_60 = 60;
  export type INTERVAL_NUM_900 = 900;
  export type INTERVAL_NUM_1800 = 1800;
  export type INTERVAL_NUM_2700 = 2700;
  export type INTERVAL_NUM_3600 = 3600;
  export type INTERVAL_NUM_86400 = 86400;
  export type INTERVAL_NUM_604800 = 604800;
  export type INTERVALS_STR =
    | INTERVAL_STR_1_MINUTE
    | INTERVAL_STR_15_MINUTES
    | INTERVAL_STR_30_MINUTES
    | INTERVAL_STR_45_MINUTES
    | INTERVAL_STR_60_MINUTES
    | INTERVAL_STR_1_DAY
    | INTERVAL_STR_1_WEEK;
  export type INTERVALS_NUM =
    | INTERVAL_NUM_60
    | INTERVAL_NUM_900
    | INTERVAL_NUM_1800
    | INTERVAL_NUM_2700
    | INTERVAL_NUM_3600
    | INTERVAL_NUM_86400
    | INTERVAL_NUM_604800;

  export type IntervalNumMap = { [key in INTERVALS_NUM]: INTERVALS_STR };
  export type IntervalStrMap = { [key in INTERVALS_STR]: INTERVALS_NUM };
  export interface Timer {
    label: string;
    interval: INTERVALS_STR;
    startDate: string;
    startTime: string;
    cmds: Commands<Mask>;
  }
  export interface TimerServer {
    interval: INTERVALS_NUM;
    start: number;
    cmds: CommandServer<MaskServer>[];
  }
  export type Data = { timers: Timer[]; newTimer: Timer };
  export type DataServer = { [x: string]: TimerServer };
  export type ServerResponse = { schedule: DataServer };
  export type ServerRequest = Partial<{ [x: string]: Partial<TimerServer> }>;
  export interface Props extends StoreState<Data> {}
}
